export default (date: Date) => {
  return new Date(date).getTime();
};